import styled, { css, keyframes } from 'styled-components';
import type { Theme } from '@/styles/theme';

const pulseDot = keyframes`
  0%, 100% { opacity: 1; }
  50% { opacity: 0.4; }
`;

export interface BadgeStyleProps {
  $modifier: 'uploaded' | 'processing' | 'ready' | 'failed';
}

const colorMap = {
  uploaded: (t: Theme) => t.colors.warning,
  processing: (t: Theme) => t.colors.info,
  ready: (t: Theme) => t.colors.success,
  failed: (t: Theme) => t.colors.danger,
};

export const StyledBadge = styled.span<BadgeStyleProps>`
  display: inline-flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing[1]};
  padding: 0.125rem ${({ theme }) => theme.spacing[2]};
  border-radius: ${({ theme }) => theme.radii.full};
  font-size: ${({ theme }) => theme.fontSizes.xs};
  font-weight: ${({ theme }) => theme.fontWeights.medium};
  background-color: ${({ theme, $modifier }) => {
    const color = colorMap[$modifier](theme);
    return `${color}1a`;
  }};
  color: ${({ theme, $modifier }) => colorMap[$modifier](theme)};

  &::before {
    content: '';
    width: 0.375rem;
    height: 0.375rem;
    border-radius: 50%;
    background-color: ${({ theme, $modifier }) => colorMap[$modifier](theme)};
    ${({ $modifier }) =>
      $modifier === 'processing' &&
      css`animation: ${pulseDot} 1.5s infinite;`}
  }
`;

export const ProgressBarThin = styled.div`
  .progress {
    height: 0.25rem;
    min-width: 5rem;
  }
`;
